import * as React from "react";

function SvgSuccessCheckCircle(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={38} height={38} {...props}>
        <path
          d="M19 38a19 19 0 1119-19 19.022 19.022 0 01-19 19zM8.319 21.316a1.19 1.19 0 00-.842 2.03l5.9 5.635a1.19 1.19 0 001.682 0l15.428-15.017A1.191 1.191 0 0028.8 12.28L14.216 26.459l-5.055-4.794a1.186 1.186 0 00-.842-.349z"
          fill="#4caf50"
        />
      </svg>
    </span>
  );
}

export default SvgSuccessCheckCircle;
